import { render } from "./AlertBox.vue?vue&type=template&id=a7dc844e&scoped=true&ts=true"
import script from "./AlertBox.vue?vue&type=script&lang=ts"
export * from "./AlertBox.vue?vue&type=script&lang=ts"

import "./AlertBox.vue?vue&type=style&index=0&id=a7dc844e&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7dc844e"]])

export default __exports__